import React from "react";
import {Button, Card, Col, Image, Modal, Nav, Row, Tab, Table} from '@themesberg/react-bootstrap';
import BasePage from "./../base/BasePage";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {handleTimeAgo, isEmpty, isResponseOk, navigate, parseDate} from "enqc-utilities/src/utils/Utilities";
import label from "enqc-utilities/src/label/Label";
import Global, {DD_MMMM_YYYY_HH_MM_SS} from "../../utils/Global";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faInfo, faList, faPlus} from "@fortawesome/free-solid-svg-icons";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import {toasting} from "../base/BaseComponent";
import TextInput from "../../components/input/TextInput";
import ContainerCard from "../../components/ContainerCard";
import LocationSelectorModal from "../../components/LocationSelectorModal";
import SockJsClient from 'react-stomp';
import {HEART_BEAT_INTERVAL} from "../../Variable";
import SmartDevicePage from "./SmartDevicePage";
import SortOption from "enqc-utilities/src/model/SortOption";
import PaginationTable from "../../components/PaginationTable";
import queryString from 'query-string';
import TableSortOption from "../../components/input/TableSortOption";
import SearchInput from "../../components/input/SearchInput";
// let paymentProofTable = React.createRef()

class SmartDeviceDetailPage extends BasePage{
  paymentProofTable = React.createRef()

  constructor(props) {
    super(props);
    let {deviceId} = props.match.params
    let {tab} = props.match.params
    this.state = {
      // defaultActiveTab:SmartDeviceDetailPage.INFO,
      defaultActiveTab:"/"+tab,
      deviceId:deviceId,
      smartDevice:{},
      spotLocation:{},
      smartDeviceState:{},
      smartDeviceStatus:{},
      paymentAttribute:{},
      smartDeviceActivities:[],
      requestProcessConfirmationModal:false,
      smartDeviceStatusHistoryModal:false,
      locationSelectorModal:false,
      page: queryString.parse(props.query).page ? queryString.parse(props.query).page : 1,
      totalPage: 0,
      totalElement: 0,
      pageElement: 0,
      sortOption:SortOption.init(label.Latest,"ca.created",false)
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props!==prevProps){
      let currentTab = this.props.match.params.tab
      let previousTab = prevProps.match.params.tab

      if(currentTab!==previousTab){
        let tab = "/"+currentTab
        this.setState({defaultActiveTab:tab})
      }

    }
  }

  componentDidMount() {
    super.componentDidMount();
    if(this.props?.navBar?.current){
      this.props.navBar.current.updateNavBarItems([SmartDevicePage.PAGE_CONF, SmartDeviceDetailPage.PAGE_CONF])
    }
    // window.alert(this.state.defaultActiveTab)
    this.props.closePreLoader()
    this.fetchSmartDevice()
    this.fetchSmartDeviceActivities()
    this.fetchPaymentMediaAttribute()
  }

  fetchSmartDevice(){
    let {deviceId,smartDevice,smartDeviceState,smartDeviceStatus, spotLocation} = this.state
    this.get(Endpoint.API.SMART_DEVICE, {params:{
        "deviceId":deviceId
      }}, null, (res)=>{
      if(isResponseOk(res)){
        smartDevice = res.data
        spotLocation = smartDevice.spotLocation
        smartDeviceState = smartDevice.smartDeviceState
        smartDeviceStatus = smartDevice.smartDeviceStatus
        this.setState({smartDevice,smartDeviceState,smartDeviceStatus, spotLocation})
      }else{
        // navigate(this.props, DashboardPage.ENDPOINT)
      }
    }, true, true)
  }

  fetchPaymentMediaAttribute(){
    let {paymentAttribute} = this.state
    this.get(Endpoint.API.PAYMENT_MEDIA_ATTRIBUTE, {}, null, (res)=>{
      if(isResponseOk(res)){
        paymentAttribute = res.data
        this.setState({paymentAttribute})
      }
    }, true, true)
  }

  requestToProcess(){
    let {deviceId,smartDevice,smartDeviceState,smartDeviceStatus, spotLocation} = this.state
    this.get(Endpoint.API.PRODUCT_ORDER_REQUEST_TO_PROCESS, {params:{
        "deviceId":deviceId
      }}, null, (res)=>{
      if(isResponseOk(res)){
        toasting.success(res.message)
        smartDevice = res.data
        spotLocation = smartDevice.spotLocation
        smartDeviceState = smartDevice.smartDeviceState
        smartDeviceStatus = smartDevice.smartDeviceStatus
        this.setState({smartDevice, spotLocation, smartDeviceState, smartDeviceStatus, requestProcessConfirmationModal:false},() => {
          if(this.paymentProofTable){
            this.paymentProofTable.current.fetchPaymentProofs()
          }
        })
      }
    }, true, true)
  }

  confirmDialogRender(){
    let {requestProcessConfirmationModal} = this.state
    return(
        <Modal as={Modal.Dialog} centered show={requestProcessConfirmationModal} onHide={()=>{}}>
          <Modal.Header>
            <Modal.Title className="h6">{label.Confirmation}</Modal.Title>
            <Button variant="close" aria-label="Close" onClick={()=>{}} />
          </Modal.Header>
          <Modal.Body className="text-center">
            <Row>
              <Col className="text-center">
                <img src={ApplicationIcons.Icons.warningAttention}/>
              </Col>
            </Row>
            <br/>
            <h4>{label.RequestToProcessTitle}</h4>
            <p>{label.RequestToProcessDescription}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
                variant="outline-warning"
                className="text-gray ms-auto"
                onClick={()=>{
                  this.setState({requestProcessConfirmationModal:false})
                }}>
              {label.Close}
            </Button>
            <Button
                variant="success"
                onClick={()=>{
                  this.requestToProcess()
                }}>
              {label.Continue}
            </Button>
          </Modal.Footer>
        </Modal>
    )
  }

  updateSpotLocation(spotLocation){
    let {smartDevice,smartDeviceState,smartDeviceStatus} = this.state
    let form = new FormData()
    form.append("smartDeviceId",smartDevice.id)
    form.append("spotLocationId",spotLocation.id)
    this.post(Endpoint.API.SMART_DEVICE_UPDATE_SPOT_LOCATION, form, null, (res)=>{
      if(isResponseOk(res)){
        toasting.success(res.message)
        smartDevice = res.data
        spotLocation = smartDevice.spotLocation
        smartDeviceState = smartDevice.smartDeviceState
        smartDeviceStatus = smartDevice.smartDeviceStatus
        this.setState({smartDevice,smartDeviceState,smartDeviceStatus, spotLocation})
      }
    }, true, true)
  }

  locationSelectionModal(){
    let {locationSelectorModal} = this.state
    return(
        <LocationSelectorModal
            show={locationSelectorModal}
            onClose={() =>{
              this.setState({locationSelectorModal:false})
            }}
            onSelectLocation={(spotLocation) => {
              this.setState({locationSelectorModal:false},() => {
                this.updateSpotLocation(spotLocation)
              })
            }}
        />
    )
  }

  fetchSmartDeviceActivities = () => {
    let {smartDeviceActivities, sortOption, search, deviceId} = this.state
    this.get(Endpoint.API.SMART_DEVICE_ACTIVITIES, {
      params :{
        deviceId:deviceId,
        ascending: sortOption.ascending,
        search: search,
        sortir: sortOption.sortir,
        page: this.state.page - 1,
      }
    }, null, response=>{
      if(response.code===200){
        let smartDeviceActivities = response.data
        let totalPage = response.totalPage
        let totalElement = response.totalElement
        let pageElement = response.pageElement
        this.setState({smartDeviceActivities:smartDeviceActivities,totalPage, totalElement, pageElement})
      }else{
        this.props.history.goBack();
      }
    }, false, true)
  }



  render(){
    let {deviceId, smartDevice, smartDeviceStatus, smartDeviceState, spotLocation,
      defaultActiveTab, smartDeviceActivities, page, pageElement, totalPage, totalElement, sortOption} = this.state
    return (
        <>
          {this.locationSelectionModal()}
          <Row>
            <Col xs={12} xl={3}>
              <Row>
                <Col xs={12}>
                  <Card border="light" className="text-center p-0 mb-4">
                    <Card.Header className="pb-1">
                      <Card.Title>{label.DeviceInformation}</Card.Title>
                    </Card.Header>
                    <Card.Body className="p-2">
                      <Row className="pt-0 pl-3 pr-3">
                        <Col className="text-left">
                          <TextInput
                              label={label.Label}
                              readOnly={true}
                              value={smartDevice.label}
                              size={"sm"}
                          />
                        </Col>
                      </Row>
                      <Row className="pt-0 pl-3 pr-3">
                        <Col className="text-left">
                          <TextInput
                              label={label.PublicIpAddress}
                              readOnly={true}
                              value={smartDevice.publicIpAddress}
                              size={"sm"}
                          />
                        </Col>
                      </Row>
                      <Row className="pt-0 pl-3 pr-3">
                        <Col className="text-left">
                          <TextInput
                              label={label.LocalIpAddress}
                              readOnly={true}
                              value={smartDevice.localIpAddress}
                              size={"sm"}
                          />
                        </Col>
                      </Row>
                      <Row className="pt-0 pl-3 pr-3">
                        <Col className="text-left">
                          <TextInput
                              label={label.DeviceId}
                              readOnly={true}
                              value={smartDevice.deviceId}
                              size={"sm"}
                          />
                        </Col>
                      </Row>
                      <Row className="pt-0 pl-3 pr-3">
                        <Col className="text-left">
                          <TextInput
                              label={label.UUID}
                              readOnly={true}
                              value={smartDevice.uuidCode}
                              size={"sm"}
                          />
                        </Col>
                      </Row>
                      <Row className="pt-0 pl-3 pr-3">
                        <Col className="text-left">
                          <TextInput
                              label={label.ShortCode}
                              readOnly={true}
                              value={smartDevice.shortCode}
                              size={"sm"}
                          />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
            <Col xs={12} xl={9}>
              {!isEmpty(defaultActiveTab)?(
                  <>
                    <Tab.Container defaultActiveKey={defaultActiveTab}>
                      <Nav fill variant="tabs" className="flex-column flex-sm-row p-0 w-25">
                        <Nav.Link
                            eventKey={SmartDeviceDetailPage.INFO}
                            className={"p-2 text-black "+(SmartDeviceDetailPage.INFO === defaultActiveTab?'bg-white':'bg-body')}
                            onSelect={eventKey => {
                              navigate(this.props, SmartDeviceDetailPage.ENDPOINT+"/"+deviceId+SmartDeviceDetailPage.INFO)
                              // this.setState({defaultActiveTab:SmartDeviceDetailPage.INFO})
                            }}
                            disabled={false}>
                          <FontAwesomeIcon style={{width:'14px',height:'14px', color:(SmartDeviceDetailPage.INFO === defaultActiveTab?'black':'gray')}} icon={faInfo} />&nbsp;&nbsp;
                          <span style={{color:(SmartDeviceDetailPage.INFO === defaultActiveTab?'black':'gray')}}>{label.Information}</span>
                          <span style={{color:(SmartDeviceDetailPage.INFO === defaultActiveTab?'black':'gray'), fontWeight:'bold'}}></span>
                        </Nav.Link>
                        <Nav.Link
                            eventKey={SmartDeviceDetailPage.ACTIVITY}
                            className={"p-2 text-black "+(SmartDeviceDetailPage.ACTIVITY === defaultActiveTab?'bg-white':'bg-body')}
                            onSelect={eventKey => {
                              navigate(this.props, SmartDeviceDetailPage.ENDPOINT+"/"+deviceId+SmartDeviceDetailPage.ACTIVITY)
                              // this.setState({defaultActiveTab:SmartDeviceDetailPage.ACTIVITY})
                            }}
                            disabled={false}>
                          <FontAwesomeIcon style={{width:'14px',height:'14px', color:(SmartDeviceDetailPage.ACTIVITY === defaultActiveTab?'black':'gray')}} icon={faList} />&nbsp;&nbsp;
                          <span style={{color:(SmartDeviceDetailPage.ACTIVITY === defaultActiveTab?'black':'gray')}}>{label.Activity}</span>
                          <span style={{color:(SmartDeviceDetailPage.ACTIVITY === defaultActiveTab?'black':'gray'), fontWeight:'bold'}}></span>
                        </Nav.Link>
                      </Nav>
                      <Tab.Content className="p-1 bg-white">
                        <Tab.Pane eventKey={SmartDeviceDetailPage.INFO} className="p-4">
                          <React.Fragment>
                            <Row>
                              <Col xs={5}>
                                <Card border="light" className="bg-white shadow-sm mb-4 p-0">
                                  <Card.Header>
                                    <Row>
                                      <Col>
                                        {label.Status}
                                      </Col>
                                      <Col className="text-right p-0">
                                        <Button
                                            variant="outline-warning"
                                            size="sm"
                                            style={{width:'24px',height:'24px'}}
                                            className="rounded-circle p-0"
                                            onClick={(event) => {
                                              event.preventDefault()
                                              this.setState({smartDeviceStatusHistoryModal:true})
                                            }}>
                                          <FontAwesomeIcon style={{width:'12px',height:'12px'}} icon={faInfo} />
                                        </Button>
                                      </Col>
                                    </Row>
                                  </Card.Header>
                                  <Card.Body>
                                    <div className="d-xl-flex align-items-center">
                                      <div className="user-avatar xl-avatar">
                                        <Image fluid rounded src={Global.DEVICE_STATUS_ICONS[smartDeviceStatus.icon]} />
                                      </div>
                                      <div className="file-field">
                                        <div className="d-flex justify-content-xl-center ms-xl-3">
                                          <div className="d-flex">
                                            <div className="d-md-block text-start">
                                              <div className="fw-normal font-weight-bold mb-1 rounded px-2 text-white" style={{backgroundColor:smartDeviceStatus.color}}>{smartDeviceStatus.label}</div>
                                              <div className="text-gray small">{label.UpdatedAt} {handleTimeAgo(smartDevice.updated)}</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Card.Body>
                                  <Card.Footer className="border-warning p-3">
                                    <span className="rounded pt-1 px-4 pb-1 text-white" style={{fontSize:'12px', fontStyle:'italic', fontWeight:'bold', backgroundColor:smartDeviceState.color}}>{smartDeviceState.label}</span>
                                  </Card.Footer>
                                </Card>
                              </Col>
                              <Col xs={5}>
                                <Card border="light" className="bg-white shadow-sm mb-4">
                                  <Card.Header>
                                    <Row>
                                      <Col>
                                        {label.Location}
                                      </Col>
                                      <Col className="text-right p-0">
                                        <Button
                                            size="sm"
                                            variant={!smartDevice.spotLocation?"success":"warning"}
                                            onClick={event => {
                                              this.setState({locationSelectorModal:true})
                                            }}>
                                          {label.SelectLocation}&nbsp;
                                          <FontAwesomeIcon style={{width:'12px',height:'12px'}} icon={faPlus} />
                                        </Button>
                                      </Col>
                                    </Row>
                                  </Card.Header>
                                  <Card.Body>
                                    <div className="d-xl-flex align-items-center">
                                      <div className="user-avatar xl-avatar">
                                        <Image fluid rounded src={ApplicationIcons.Icons.markerMap} />
                                      </div>
                                      <div className="file-field">
                                        <div className="d-flex justify-content-xl-center ms-xl-3">
                                          <div className="d-flex">
                                            <div className="d-md-block text-start">
                                              <div className="fw-normal font-weight-bold mb-1 rounded px-2">{!isEmpty(spotLocation.name)?spotLocation.name:label.NoInformation}</div>
                                              <div className="text-gray small">{!isEmpty(spotLocation.phoneNumber)?spotLocation.phoneNumber:"-"}</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Card.Body>
                                  <Card.Footer className="border-warning p-3">
                      <span className={!isEmpty(spotLocation.name)?"text-info":"text-danger"} style={{fontSize:'12px', fontStyle:'italic', fontWeight:'bold'}}>
                        {
                          isEmpty(spotLocation.name)? (label.PleaseFillUpDeviceLocated):(spotLocation.address+", "+spotLocation.regional)
                        }
                      </span>
                                  </Card.Footer>
                                </Card>
                              </Col>
                              <Col xs={2}>
                                <Card border="light" className="bg-white shadow-sm" style={{height:'90%'}}>
                                  <Card.Header>
                                    {label.AvailableItem}
                                  </Card.Header>
                                  <Card.Body class="d-flex justify-content-center align-items-center h-100">
                                    <span className="text-info" style={{fontSize:'48px'}}>0</span>
                                  </Card.Body>
                                </Card>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={12} xs={12} xl={12}>
                                <ContainerCard smartDevice={smartDevice}/>
                              </Col>
                            </Row>
                          </React.Fragment>
                        </Tab.Pane>
                        <Tab.Pane eventKey={SmartDeviceDetailPage.ACTIVITY} className="p-4">
                          <React.Fragment>
                            <div className="table-settings mb-4">
                              <Row className="align-items-center">
                                <Col xs={8} md={6} lg={3} xl={7}>
                                </Col>
                                <Col xs={4} md={4} xl={1} className="ps-md-0 text-right">
                                  <TableSortOption
                                      sortOptions={
                                        [
                                          SortOption.init(label.Latest,"ca.created",false),
                                          SortOption.init(label.Oldest,"ca.created",true),
                                          SortOption.init(label.Name,"u.firstname",true),
                                        ]
                                      }
                                      sortOption={sortOption}
                                      placeholder={label.SortBy}
                                      onSelect={(sortOption) => {
                                        this.setState({sortOption},() => {
                                          this.fetchSmartDeviceActivities()
                                        })
                                      }}
                                      onReset={() => {
                                        this.setState({sortOption:{}},() => {
                                          this.fetchSmartDeviceActivities()
                                        })
                                      }}/>
                                </Col>
                                <Col xs={8} md={6} lg={3} xl={4}>
                                  <SearchInput onEnter={(search) => {
                                    this.setState({search}, () => {
                                      this.fetchSmartDeviceActivities()
                                    })
                                  }} onEmpty={() => {
                                    this.setState({search:""},() => {
                                      this.fetchSmartDeviceActivities()
                                    })
                                  }}/>
                                </Col>
                              </Row>
                            </div>
                            <Card border="light" className="table-wrapper table-responsive shadow-sm">
                              <Card.Body className="p-0">
                                <Table responsive className="table-flush table-striped table-sm text-wrap">
                                  <thead className="thead-light">
                                  <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">{label.User}</th>
                                    <th scope="col">{label.Title}</th>
                                    <th scope="col">{label.Description}</th>
                                    <th scope="col">{label.TimeActivity}</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  {smartDeviceActivities.map((smartDeviceActivity, index) => {
                                    return (
                                        <tr>
                                          <td>{((page - 1) * pageElement) + (index+1)}</td>
                                          <td>{smartDeviceActivity.user.fullname}</td>
                                          <td>{smartDeviceActivity.title}</td>
                                          <td className="text-wrap">{smartDeviceActivity.description}</td>
                                          <td>{parseDate(smartDeviceActivity.created, DD_MMMM_YYYY_HH_MM_SS)}</td>
                                        </tr>
                                    )
                                  })}
                                  </tbody>
                                </Table>
                              </Card.Body>
                              <PaginationTable
                                  onSelect={(page) => {
                                    this.setState({page}, () => {
                                      this.fetchSmartDeviceActivities()
                                    })
                                  }}
                                  showingRow={smartDeviceActivities.length}
                                  currentPage={page}
                                  pageCount={totalPage}
                                  totalElement={totalElement}/>
                            </Card>
                          </React.Fragment>
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                  </>
              ):defaultActiveTab
              }
            </Col>
          </Row>
          {this.confirmDialogRender()}
          <SockJsClient
              url={Global.BASE_URL}
              topics={["/listen/"+smartDevice.deviceId+"/refresh"]}
              heartbeat={HEART_BEAT_INTERVAL}
              debug={Global.DEBUG}
              autoReconnect={false}
              onMessage={(message) => {
                this.setState({smartDeviceState:message})
                console.log(message)
              }}/>
        </>
    );
  };
}
// export default Object.assign(SmartDeviceDetailPage, {ENDPOINT : "/smartDeviceDetail"})

const INFO = "/info"
const ACTIVITY = "/activity"
const ENDPOINT = "/smartDeviceDetail"
const TITLE = label.SmartDeviceDetail
const PAGE = {ENDPOINT: ENDPOINT, INFO:INFO, ACTIVITY:ACTIVITY, PAGE_CONF: {ENDPOINT, TITLE}}
export default Object.assign(SmartDeviceDetailPage, PAGE)

